var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 609,
    height: 229,
    viewBox: "0 0 609 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 524,
    cy: 121,
    r: 14,
    fill: "#1920AC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 209,
    r: 14,
    fill: "#1920AC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 116,
    r: 9,
    fill: "#1920AC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 537,
    cy: 220,
    r: 9,
    fill: "#1920AC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 151,
    r: 9,
    fill: "#1920AC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 488,
    cy: 78,
    r: 14,
    fill: "#1920AC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 165,
    r: 14,
    fill: "#1920AC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 149,
    r: 14,
    fill: "#1920AC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 177,
    r: 9,
    fill: "#1920AC"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 107.5,
    r: 25.5,
    fill: "#1920AC"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.5,
    cy: 25.5,
    r: 25.5,
    fill: "#1920AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalls);
export default __webpack_public_path__ + "static/media/balls.89a682cf2ce33cb860685ac87e91f41d.svg";
export { ForwardRef as ReactComponent };